import { useEffect, useState } from 'react';
import { tippspielAPI } from '../services/api';

export const DEFAULT_SCORING = {
  exactScorePoints: 5,
  correctGoalDifferencePoints: 3,
  correctTendencyPoints: 2,
  correctDrawPoints: 3,
  wrongTipPoints: 0,
  missedTipPoints: 0,
};

const FALLBACK = {
  seasonLabel: '26/27',
  projectName: '',
  scoring: DEFAULT_SCORING,
};

export function useTippspielBranding() {
  const [branding, setBranding] = useState(FALLBACK);

  useEffect(() => {
    tippspielAPI.getInfo()
      .then((res) => setBranding({
        ...FALLBACK,
        ...res.data,
        scoring: res.data?.scoring || DEFAULT_SCORING,
      }))
      .catch(() => setBranding(FALLBACK));
  }, []);

  return branding;
}

export function scoringLines(scoring) {
  const r = scoring || DEFAULT_SCORING;
  return [
    `Exaktes Ergebnis: ${r.exactScorePoints} Punkte`,
    `Richtige Tordifferenz (falsche Tore): ${r.correctGoalDifferencePoints} Punkte`,
    `Richtige Tendenz (Sieg/Unentschieden/Niederlage): ${r.correctTendencyPoints} Punkte`,
    `Richtiges Unentschieden (falsche Tore): ${r.correctDrawPoints} Punkte`,
    `Falscher Tipp: ${r.wrongTipPoints} Punkte`,
  ];
}
